import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Badge,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';

import {
  getSubjects,
  addToFavorites,
} from '../../redux/actions/professorActions';
import { fetchFormDatas } from '../../redux/actions/periodoActions';
import { SidebarProps } from '../../shared/prop-types/ReducerProps';

import {
  createErrorMessage,
  createWarningMessage,
  createSuccessMessage,
} from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { Roles } from '../../constants/enums';

class ProfesorSubjectsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    const user = JSON.parse(localStorage.getItem('currentUser')) || {};

    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 20 },
      periodos: [],
    };
    this.columns = [
      {
        key: 'mostrarEnTablero',
        name: 'Tablero',
        width: '80px',
        search: false,
        visible: this.showStarIcon(user),
        icon: {
          callback: row => (this.onAddToFavoritesSubmit(row)),
          component: row => (
            <span
              className={row.mostrarEnTablero ? 'fa fa-star' : 'fa fa-star-o'}
              title={row.mostrarEnTablero ? 'Quitar del tablero' : 'Mostrar en el tablero'}
            />
          ),
        },
      },
      {
        key: 'profesor',
        name: 'Profesor',
        search: this.showNombre(user),
        visible: this.showNombre(user),
      },
      {
        key: 'codigoMateria',
        name: 'Codigo Materia',
        search: true,
        visible: false,
      },
      {
        key: 'materia',
        name: 'Materia',
        format: row => `${row.codigoMateria} - ${row.materia} - ${row.seccion}`,
        search: true,
        width: '300px',
      },
      {
        key: 'periodo',
        name: 'Periodo',
        search: true,
        visible: true,
        className: 'text-center',
        width: '200px',
        type: 'select',
        searchProps: {
          options: this.getPeriodos,
        },
        format: row => `${row.periodo ? row.periodo : '-'}`,
      },
      {
        key: 'malla',
        name: 'Malla',
        width: '190px',
        className: 'text-center',
        search: true,
        format: row => row.malla,
      },
      {
        key: 'numeroSemestre',
        name: 'Semestre',
        type: 'number',
        search: true,
        format: row => `${row.semestreNroOrden}º`,
        width: '70px',
        className: 'text-center',
      },
      {
        key: 'cantidadInscriptos',
        name: 'Alumnos',
        type: 'number',
        search: false,
        format: row => (
          <h5>
            <Badge
              color={row.cantidadInscriptos > 0 ? 'primary' : 'secondary'}
              pill
            >
              {row.cantidadInscriptos}
            </Badge>
          </h5>
        ),
        width: '70px',
        className: 'text-center',
      },
      { key: 'actions', name: 'Acción', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar fila" />,
        callback: (row) => {
          this.editRow(row);
        },
      },
    ];
  }

  componentDidMount() {
    this.fetchDatasList();
  }

  getViewPageAs = () => {
    const { sidebar: { viewPageAs } } = this.props;
    return viewPageAs;
  }

  showStarIcon = (user) => {
    const viewAsProfesor = this.getViewPageAs() === Roles.Profesor;
    return (user.esProfesor && !user.esAdmin) || (user.esProfesor && user.esAdmin && viewAsProfesor);
  }

  showNombre = (user) => {
    const viewAsAdmin = this.getViewPageAs() === Roles.Admin;
    return user.esAdmin && viewAsAdmin;
  }

  updateSubjectsTable = (page, pageSize, filters = {}) => {
    const {
      periodo = { value: 0, label: '-' },
      numeroSemestre = 0,
    } = filters;

    const params = {
      ...filters,
      numeroSemestre: Number(numeroSemestre),
      periodoId: periodo.value,
    };

    this.setState({
      loading: true,
      page,
      pageSize,
      filters: params,
    });

    const { sidebar: { viewPageAs } } = this.props;

    getSubjects(
      viewPageAs !== 0,
      {
        pageInfo: {
          page,
          pageSize,
          filters: params,
        },
        onSuccess: (pageInfo) => {
          this.setState({
            loading: false,
            items: pageInfo.items,
            totalItemsCount: pageInfo.totalItemsCount,
          });
        },
        onError: () => {
          this.setState({ items: [], loading: false });
          createErrorMessage('Error al intentar cargar la lista de materias');
        },
      },
    );
  }

  fetchDatasList = () => {
    this.setState({
      loading: true,
    });

    fetchFormDatas({
      onSuccess: ({ periodos }) => {
        this.setState({
          periodos,
          loading: false,
        });

        const { page, pageSize } = this.state;
        this.updateSubjectsTable(page, pageSize);
      },
      onError: (error) => {
        console.log(error);
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  editRow = (row) => {
    const { history } = this.props;
    history.push(`/pages/profesor-subjects/${row.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateSubjectsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateSubjectsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateSubjectsTable(1, pageSize, {});
  };

  onAddToFavoritesSubmit = (row) => {
    if (row) {
      addToFavorites(row.id, {
        onSuccess: () => {
          const { items } = this.state;

          const newState = items.map(item => (
            item.id === row.id ? { ...item, mostrarEnTablero: !row.mostrarEnTablero } : item
          ));

          this.setState({
            items: newState,
          });

          createSuccessMessage(
            `Materia ${(!row.mostrarEnTablero ? 'agregada al' : 'quitada del')} tablero exitosamente`,
          );
        },
        onError: async (error) => {
          if (error.message) {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Error al intentar quitar la materia del tablero ');
          }
        },
      });
    }
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  getPeriodos = () => {
    const { periodos = [] } = this.state;

    return periodos;
  };

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Materias asignadas</h3>
          </Col>
        </Row>
        <Row>
          {loading ? <LoadingSpinner />
            : (
              <DataTable
                title="Listado de todas las materias del profesor"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

ProfesorSubjectsContainer.propTypes = {
  sidebar: SidebarProps.isRequired,
};

export default withRouter(connect(state => ({
  sidebar: state.sidebar,
}))(ProfesorSubjectsContainer));
